<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="16">
              <el-select v-model="cangkucode" placeholder="发货仓库" style="width: 150px;" :clearable="true" size="mini">
                <el-option v-for="item in jxcstoreDatas" :key="item.cangkucode"
                           :label="item.cangkuname" :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-select v-model="cangkucode2" placeholder="收货仓库" style="width: 150px;" :clearable="true" size="mini">
                <el-option v-for="item in jxcstoreDatas" :key="item.cangkucode"
                           :label="item.cangkuname" :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-input style="width:150px;" size="mini"
                        placeholder="调拨单号"
                        prefix-icon="el-icon-search"
                        v-model="erpserial">
              </el-input>
              <el-select v-model="datesearch" placeholder="按发货时间" style="width: 120px;" size="mini">
                <el-option key="10" label="按录入时间" value="10"></el-option>
                <el-option key="20" label="按发货时间" value="20"></el-option>
                <el-option key="30" label="按到货时间" value="30"></el-option>
              </el-select>
              <el-date-picker style="width:110px" size="mini"
                              v-model="begindate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="开始日期">
              </el-date-picker>
              <el-date-picker style="width:110px" size="mini"
                              v-model="enddate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="结束日期">
              </el-date-picker>
              <el-select v-model="logisticsco" placeholder="请选择" style="width: 150px;" size="mini">
                <el-option
                  v-for="item in parameterData"
                  :key="item.value"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini"
                        style="width:150px;"
                        @clear="clearSeedCode">
              </el-input>
              <el-input style="width:150px;" size="mini"
                        placeholder="物流单号"
                        prefix-icon="el-icon-search"
                        v-model="logisticsnum">
              </el-input>
              <el-radio-group v-model="status" size="mini" @change="bindInit">
                <el-radio-button :label="''" :key="''">全部</el-radio-button>
                <!--<el-radio-button :label="'-20'" :key="'-20'">待审核</el-radio-button>-->
                <el-radio-button :label="'-10'" :key="'-10'">待发货</el-radio-button>
                <el-radio-button :label="'0'" :key="'0'">待收货</el-radio-button>
                <el-radio-button :label="'10'" :key="'10'">已办结</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid(false)" size="mini">搜索
            </el-button>
            <el-button type="warning" v-on:click="allocation('','',0,'80')" size="mini">镜架调拨</el-button>
            <el-button type="warning" v-on:click="allocation('','',0,'')" size="mini">镜片调拨</el-button>
            <el-button type="warning" v-on:click="allocation('','',0,'40')" size="mini">其他调拨</el-button>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(160)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            fixed
            prop="erpserial"
            label="调拨单号"
            align="center"
            width="130"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="pingpai" :show-overflow-tooltip="true"
            label="品牌"
            align="left"
            width="80"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedname" :show-overflow-tooltip="true"
            label="名称"
            align="left"
            width="150"
            header-align="center">
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="seedcode" :show-overflow-tooltip="true"-->
            <!--label="编码"-->
            <!--align="center"-->
            <!--width="100"-->
            <!--header-align="center">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="cangkuname" :show-overflow-tooltip="true"
            label="发货仓"
            align="left"
            width="180"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="cangkuname2" :show-overflow-tooltip="true"
            label="收货仓"
            align="left"
            width="180"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="总数"
            align="center"
            width="60"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="uname"
            label="开单人" :show-overflow-tooltip="true"
            align="left"
            width="120"
            text-align="center">
          </el-table-column>
          <el-table-column
            align="center"
            label="开单日期" width="90">
            <template slot-scope="scope">
              {{(scope.row.adddate || "").substring(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="发货日期" width="140">
            <template slot-scope="scope">
              {{(scope.row.accdate || "")}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="收货日期" width="140">
            <template slot-scope="scope">
              {{(scope.row.handleoverdate || "")}}
            </template>
          </el-table-column>
          <el-table-column
            prop="logisticsco"
            label="物流公司" :show-overflow-tooltip="true"
            align="left"
            width="120"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="logisticsnum" :show-overflow-tooltip="true"
            label="物流单号"
            align="left"
            width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="状态"
            align="left"
            fixed="right"
            width="60"
            text-align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status==-20" style="color:red">待审核</span>
              <span v-if="scope.row.status==-10&&roletype=='order'">待发货</span>
              <span v-if="scope.row.status==-10&&roletype=='store'" style="color:red">待发货</span>
              <!--<span v-if="scope.row.status==-10&&scope.row.printCount==undefined" style="color:red"> 未打印</span>-->
              <span v-if="scope.row.status==0" style="color:blue">待收货</span>
              <span v-if="scope.row.status==10">已办结</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="240px">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" v-if="roletype=='store'&&scope.row.status==10&&!independentserial&&scope.row.cangkucode2.indexOf('@')==-1" @click="back2Cus(scope.$index, scope.row)">退供应商</el-button>
              <el-button size="mini" type="success" v-if="roletype=='store'&&scope.row.status==-10&&manageCangKu(scope.row.cangkucode,scope.row)" @click="fahuo(scope.$index, scope.row)">发货</el-button>
              <el-button size="mini" type="danger" v-if="roletype=='store'&&scope.row.status==0&&manageCangKu(scope.row.cangkucode2,scope.row)" @click="handlesaleCsagreementToVoid(scope.$index, scope.row)">收货</el-button>
              <el-button size="mini" v-if="roletype=='order'&& (!independentserial&&scope.row.status==-20 )" v-on:click="allocation(scope.$index, scope.row,1)">审核</el-button>
              <el-button size="mini" v-if="userInfoModel.uguid==scope.row.uguid&&(scope.row.status==-10||scope.row.status==-20 )" v-on:click="allocation(scope.$index, scope.row,1)">修改</el-button>
              <el-button size="mini" type="danger"  v-if="userInfoModel.uguid==scope.row.uguid&&roletype=='store'&&scope.row.status==0&&manageCangKu(scope.row.cangkucode,scope.row)"
                         @click="drawRow(scope.$index, scope.row)">撤回
              </el-button>
              <el-button size="mini"
                         v-if="userInfoModel.uguid==scope.row.uguid&&(scope.row.status==-10||scope.row.status==-20 )"
                         @click="deleteRow(scope.$index, scope.row)">删除
              </el-button>
              <el-button size="mini" v-else @click="lookDetails(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
        <AllocationDetail ref="DataContactDetail" @bindGrid="bindGrid"></AllocationDetail>
        <AllocationEditNew ref="DataContactEdit2" @bindGrid="bindGrid"></AllocationEditNew>
        <AllocationEdit40 ref="DataContactEdit40" @bindGrid="bindGrid"></AllocationEdit40>
        <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
        <BatchBuyorderDetailEdit ref="BatchBuyorderDetailEdit1" :fromdiaobo="true"></BatchBuyorderDetailEdit>
      </div>
    </el-col>
  </div>
</template>

<script>
  import {getjxcList, updatejxc, deleteData,drawData,getDetail} from '@/api/set/allocation';
  import AllocationDetail from './AllocationDetail';
  import AllocationEditNew from './AllocationEditNew';
  import AllocationEdit40 from './AllocationEdit40';
  import {getListDataall} from '@/api/set/jxcstore';
  import {getParameterDetail} from '@/api/set/parameter';
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel'
  import BatchBuyorderDetailEdit from '@/components/testorder/buyagreement/BatchBuyorderDetailEdit'

  export default {
    name: '调拨单',
    data() {
      return {
        msg: 'Welcome to Your Vue.js Ap22p',
        dialogFormVisible: false,
        searchdata: "",
        begindate: this.begindate,
        enddate: this.enddate,
        loading: true,
        status: "",
        seedcode: "",
        categorycode: '',
        seedname: '',
        dataname: "",
        seedgoods: '',
        datesearch: '20',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        controlData: {},
        isshwoupdate: '',
        independentserial: '',
        jxcstoreDatas: [],
        cangkucode: '',
        cangkucode2: '',
        erpserial: '',
        uname: '',
        cangkuname2: '',
        seedinfo: '',
        logisticsco: '',
        logisticsnum: '',
        parameterData: [],
        cangkumanage: '',
      }
    },
    props: {
      mystatus: {
        default: ''
      },
      roletype: {
        default: ''
      },
      canMultySelect: {
        default: true
      }
    },
    methods: {
      manageCangKu(cangkucode,row) {//管理的仓库
        if (cangkucode.indexOf('@') > -1) {
          if (this.userInfoModel.tenantid != cangkucode.split('@')[0]) {
            return false;
          }
          cangkucode = cangkucode.split('@')[1]
        } else {
          if (row.tenantid != this.userInfoModel.tenantid) return false;
        }
        if (this.jxcstoreDatas.length <= 1) return true;//只有一个仓库的时候 不要配权限
        if (this.cangkumanage.indexOf(';' + cangkucode + ';') > -1)
          return true;
        return false;
      },
      lookDetails(index, row) {
        this.$refs.DataContactDetail.initData(row)
        this.OpenDialog()
      },
      fahuo(index, row) {
        this.$refs.DataContactDetail.initData(row, 'fahuo')
        this.OpenDialog()
      },
      back2Cus(index,row) {//退供应商
        getDetail({unitguid: row.unitguid, erpserial: row.erpserial}).then(respnse => {
          this.$refs.BatchBuyorderDetailEdit1.show();
          this.$refs.BatchBuyorderDetailEdit1.initData({cangkucode: row.cangkucode2, cangkuname: row.cangkuname2})

          var arr = []
          for (let i in respnse.data.obj.seedgooddlist) {
            var item = respnse.data.obj.seedgooddlist[i];
            if (!item.packagesize) continue;
            var pagsize = JSON.parse(item.packagesize);
            if (!pagsize.M) continue;
            arr.push({
              seedcode: item.seedcode,
              seedname: item.seedname,
              color: pagsize.C,
              model: pagsize.M,
              categorycode: item.categorycode,
              totalnumber: -parseInt(item.totalnumber),
            })
          }
          console.log(arr)
          this.$refs.BatchBuyorderDetailEdit1.afterSelectCode(arr);
        })
      },
      handlesaleCsagreementToVoid(index, row) {
        this.$refs.DataContactDetail.initData(row, 'shouhuo')
        this.OpenDialog()
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = ";" + row.seedcode + ","
        this.seedname = row.seedname
        this.bindGrid()
      },
      drawRow(index, row) {
        this.$confirm('是否确定撤回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          drawData({erpserial: row.erpserial}).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '撤回成功，请到待发货中查看!'
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
            this.bindGrid();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤回'
          });
        });
      },
      deleteRow(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({erpserial: row.erpserial}).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
            this.bindGrid();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      bindInit() {
        if (this.roletype == 'store') {
          var cangks = this.cangkumanage.split(';')
          for (var ck in cangks) {
            if (cangks[ck] != '') {
              if (this.status == '0') {//待收货
                this.cangkucode2 = cangks[ck];
                this.cangkucode = '';
              } else if (this.status == '-10') {//待发货
                this.cangkucode = cangks[ck];
                this.cangkucode2 = '';
              } else {
                this.cangkucode = '';
                this.cangkucode2 = '';
              }
              break;
            }
          }
        }
        this.bindGrid();
      },
      bindGrid(rebindtip) {
        if (rebindtip)
          this.$emit("bindTip");

        getjxcList({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          begindate: this.begindate,
          enddate: this.enddate,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          formtype: 77,
          erpserial: this.erpserial,
          uname: this.uname,
          cangkucode: this.cangkucode,
          cangkucode2: this.cangkucode2,
          logisticsco: this.logisticsco,
          logisticsnum: this.logisticsnum,
          datesearch: this.datesearch,
          status: this.status
        }).then(response => {
          this.tableData = response.data.obj.rows
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].linkman = this.tableData[i].linkman + this.tableData[i].linkmantel
          }
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      OpenDialog() {
        this.$refs.DataContactDetail.show()
      },
      allocation(index, item, isupdate, filltemplate) {
        if(isupdate!=null&&isupdate==1){
          if(item.seedinfo=='其他商品')
            filltemplate='40'
        }

        if (filltemplate == '40') {
          this.$refs.DataContactEdit40.show()
          this.$refs.DataContactEdit40.initData(item, isupdate, filltemplate)
        } else {
          this.$refs.DataContactEdit2.show()
          this.$refs.DataContactEdit2.initData(item, isupdate, filltemplate)
        }
      },
    },
    mounted() {

      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.cangkumanage = ';' + this.userInfoModel.cangku + ';';
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      getListDataall().then(response => {
        this.jxcstoreDatas = response.data.obj
        if (this.roletype == 'store')
          this.status = '';//默认待发货状态
        this.bindInit();
      })

      getParameterDetail({paraname: "快递公司"}).then(response => {
        this.parameterData = JSON.parse(response.data.obj.paracontent);
        // if(this.parameterData){
        //   this.parameterData.unshift({value:'',name:'全部'})
        // }
        this.logisticsco = ''
      })
    },
    components: {
      AllocationDetail,
      AllocationEditNew,
      AllocationEdit40,
      JxcgooddetailSel,
      BatchBuyorderDetailEdit
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/warehouse/AllocationListNew.vue